function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.193 1A.193.193 0 006 1.193c0 1.486-1.608 2.414-2.895 1.671a.193.193 0 00-.264.071l-1.807 3.13a.193.193 0 00.071.264c1.287.742 1.287 2.6 0 3.342a.193.193 0 00-.07.264l1.806 3.13a.193.193 0 00.264.07C4.392 12.394 6 13.322 6 14.808c0 .107.086.193.193.193h3.614a.193.193 0 00.193-.193c0-1.486 1.608-2.414 2.895-1.671.092.053.21.021.264-.071l1.807-3.13a.193.193 0 00-.071-.264c-1.287-.742-1.287-2.6 0-3.342a.193.193 0 00.07-.264l-1.806-3.13a.193.193 0 00-.264-.07C11.608 3.606 10 2.678 10 1.192A.193.193 0 009.807 1H6.193zM8 11a3 3 0 100-6 3 3 0 000 6z",
  fill: "currentColor"
})));